import { useSelector } from "react-redux";

import { ALL_EXPENSES } from "../../api/allApi_List";
import Expense from "../../components/expense/all/Expense";
import DialogBox from "../../components/UI/DialogBox";
import spin from "../../assets/icons/spin.png";
import { handleErrMessage } from "../../functions/handleErrMessage";
import MainPageLayout from "../../layout/MainPageLayout";
import ExpenseCategoryTabs from "../../components/expense/all/ExpenseCategoryTabs";
import useFetchData from "../../CustomHooks/useAxios/useFetchData";

const ExpensePage = () => {
  const { isLoaded } = useFetchData(ALL_EXPENSES, "allExpenses", "expenses");
  const data = useSelector((state) => state.data.data);
  const error = useSelector((state) => state.data.error);
  const errMsg = useSelector((state) => state.data.errMessage);

  const expenseCategoryTabs = <ExpenseCategoryTabs />;

  return (
    <MainPageLayout headerTabs={expenseCategoryTabs}>
      {isLoaded && !error ? (
        <Expense expenseData={data} />
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(errMsg)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading..." animateIcon={spin} />
      )}
    </MainPageLayout>
  );
};

export default ExpensePage;
